// extracted by mini-css-extract-plugin
module.exports = {"content":"OnlineBookingSuccessStep_content__1LA7g","icon":"OnlineBookingSuccessStep_icon__1G41F","dogImage":"OnlineBookingSuccessStep_dogImage__253oN"};